import { CustomJobPhase } from "hooks/jobs/job-phases/useGetJobPhase";

export type CostingMode = "STANDARD" | "SUBCONTRACTED";

export const STANDARD_COSTING_MODE: CostingMode = "STANDARD";
export const SUBCONTRACTED_COSTING_MODE: CostingMode = "SUBCONTRACTED";

const costingHeaderBorderColor = "rgba(0, 0, 0, 0.23)";
const costingHeaderBorderRadius = "4px";

export const costingHeaderFieldSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    height: "40px",
    borderRadius: costingHeaderBorderRadius,
    "& fieldset": {
      borderRadius: costingHeaderBorderRadius,
      borderColor: costingHeaderBorderColor,
    },
    "&:hover fieldset": {
      borderColor: costingHeaderBorderColor,
    },
    "&.Mui-focused fieldset": {
      borderColor: costingHeaderBorderColor,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: costingHeaderBorderRadius,
      borderColor: costingHeaderBorderColor,
    },
  },
  "& .MuiOutlinedInput-input": {
    boxSizing: "border-box",
    height: "40px",
    paddingTop: "8px",
    paddingBottom: "8px",
    paddingLeft: "14px",
  },
  "& .MuiSelect-select": {
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    minHeight: "40px",
    paddingTop: "8px",
    paddingBottom: "8px",
    paddingLeft: "14px",
  },
};

export type SubcontractorCostingFormValues = {
  costingMode: CostingMode;
  actualSubcontractorCost: string;
  actualSubcontractorName: string;
  actualSubcontractorReference: string;
};

export const getSubcontractorCostingDefaults = (
  jobPhase: CustomJobPhase
): SubcontractorCostingFormValues => ({
  costingMode: jobPhase?.costingMode || STANDARD_COSTING_MODE,
  actualSubcontractorCost: jobPhase?.actualSubcontractorCost
    ? String(Number(jobPhase.actualSubcontractorCost) / 100)
    : "",
  actualSubcontractorName: jobPhase?.actualSubcontractorName || "",
  actualSubcontractorReference: jobPhase?.actualSubcontractorReference || "",
});
